/** @format */

export const DEFAULT_DELAY = 1000;
